import React from "react"

export default function Box({children, classes, width})
{       
    const c = classes !== undefined ? ' '+classes : ' rounded white'
    
    return (
        <div className={"box"+c}>{children}</div>        
    ) 
}